/**
 * Returns a hash value for the given string.
 * @param {string} str - The string to hash.
 * @returns {number} - The hash value.
 */
export default function hash(str: string) {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i);
    hash = (hash << 5) - hash + char;
    hash = hash & hash; // Convert to 32bit integer
  }
  return hash;
}
